import React, { useEffect, useCallback } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalFrameworkMethodsPropType } from 'ui-components/prop-types/modal-framework-methods';

import { RateBrowserAdapterWrapper } from './create-label/context-adapter-wrapper';
import { RateViewerLoader } from './rate-viewer-loader';
import { emptyObject } from 'ui-components/default-props/empty';
import { RateViewerTypes } from '../../../enums/rate-viewer-types';
import { WAREHOUSE_SETTINGS_URL } from '../../../pages/settings/ship-from-locations/constants';
import * as CreateLabelActions from '../../../store/create-label-content/create-label-content.actions';
import Global from '../../../store/global-selectors';

import style from './rate-browser-modal.module.less';
import { useTrackRateBrowser } from '../../rate-viewer/use-track-rate-browser';
import { WorkflowSteps } from '../../../tracking/use-workflow-tracking';

export const RateBrowserModal = (props) => {
  const { modalFrameworkMethods, onBrowseRates } = props;
  const dispatch = useDispatch();
  const showCreateLabelContent = useSelector(Global.selectRateBrowsergetShowCreateLabelContent);
  const shipmentConfiguration = useSelector(Global.selectRateBrowsergetConfigureRatesModel) || emptyObject;
  const { closeModal } = modalFrameworkMethods;
  const history = useHistory();
  const location = useLocation();

  const onConfigureLabel = useCallback(
    ({ sellerLabelProviderId, rate, fulfillmentPlanId }) => {
      dispatch(CreateLabelActions.configureLabel(sellerLabelProviderId, rate, fulfillmentPlanId));
    },
    [dispatch],
  );

  const trackRateBrowser = useTrackRateBrowser();

  // Close RateBrowserModal when user is directed to settings/warehouses. This happens on the following errors:
  // - Incomplete pickup address. Edit
  // - Incomplete return address. Edit
  // - Local delivery needs a defined pickup window. Edit Pickup Settings
  useEffect(() => {
    if (location.state === WAREHOUSE_SETTINGS_URL) {
      closeModal();
      history.replace();
    }
  }, [closeModal, history, location]);

  const onBrowseRatesClicked = useCallback(
    (rateViewerModel) => {
      trackRateBrowser(WorkflowSteps.RATE_BROWSER_BROWSE_RATES_CLICKED, {
        rateViewerModel,
      });
      onBrowseRates(rateViewerModel);
    },
    [onBrowseRates, trackRateBrowser],
  );

  return (
    <Modal className={style['rate-browser-modal']}>
      <ModalHeader closeModal={closeModal}>
        <FormattedMessage defaultMessage='Rate Browser' description='rateBrowserModal.title' id='B2f7v1' />
      </ModalHeader>
      <ModalBody className={style['rate-browser-modal-body']}>
        <RateViewerLoader
          onBrowseRates={onBrowseRatesClicked}
          onConfigureLabel={onConfigureLabel}
          rateViewerKey={RateViewerTypes.rateBrowser}
          shipmentConfiguration={shipmentConfiguration}
          showRateViewer={!showCreateLabelContent}
        />
        {showCreateLabelContent && <RateBrowserAdapterWrapper />}
      </ModalBody>
    </Modal>
  );
};

RateBrowserModal.propTypes = {
  onBrowseRates: PropTypes.func.isRequired,
  modalFrameworkMethods: ModalFrameworkMethodsPropType.isRequired,
};
